import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import AccountTextField from '../../account-text-field';
import PhoneTextField from '../../phone-text-field';
import { RegistrationFormProps } from '../registration.types';
import SampleBill from '../../sample-bill';
import Grid from '@material-ui/core/Grid';
import BillIcon from '../../../static/sample-bill-icon.svg';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { OnlineRegistrationType } from '../../../__generated__/pge-types';

interface AccountSectionProps extends RegistrationFormProps {
  classes: any;
}

const AccountSection = (props: AccountSectionProps) => {
  const { t } = useTranslation();
  const { form } = props;

  const isBusiness =
    form.values.registrationType === OnlineRegistrationType.Commercial;

  return (
    <Grid
      container
      spacing={1}
      style={{
        justifyContent: 'flex-start',
      }}
    >
      <Grid item>
        <Typography variant={'h2'}>
          {t('CREATE_RESIDENTIAL_SUBTITLE')}
        </Typography>
        <Typography style={{ marginTop: 8, marginBottom: 0 }}>
          {isBusiness
            ? t('CREATE_BUSINESS_DESCRIPTION')
            : t('CREATE_RESIDENTIAL_DESCRIPTION')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        {form.values.registrationType ===
          OnlineRegistrationType.Residential && (
          <Grid item xs={12} md={12}>
            <Box>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  value={form.values.primaryAccountOption}
                  onChange={e => {
                    void form.setValue('primaryAccountOption', e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="accountNumber"
                    control={<Radio color="primary" />}
                    label={t('ACCOUNT_NUMBER')}
                  />
                  <FormControlLabel
                    value="phoneNumber"
                    control={<Radio color="primary" />}
                    label={t('PHONE_NUMBER')}
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={12}
          style={{ display: 'flex', marginTop: '8px', flexWrap: 'wrap' }}
        >
          {form.values.registrationType ===
            OnlineRegistrationType.Residential &&
            form.values.primaryAccountOption === 'phoneNumber' && (
              <PhoneTextField
                autoFocus={form.values.primaryAccountOption === 'phoneNumber'}
                data-testid="create-residential-phone-number"
                name="phoneNumber"
                label={t('PHONE_NUMBER')}
                autoComplete="telephone"
                {...form.props('phoneNumber')}
              />
            )}
          {form.values.primaryAccountOption === 'accountNumber' && (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}
            >
              <AccountTextField
                autoFocus={form.values.primaryAccountOption === 'accountNumber'}
                data-testid="create-residential-acccount-number"
                name="accountNumber"
                label={t('ACCOUNT_NUMBER')}
                autoComplete={t('ACCOUNT_NUMBER')}
                {...form.props('accountNumber')}
              />
              <SampleBill tabIndex={-1}>
                <Box
                  data-testid="sample-bill"
                  style={{
                    display: 'flex',
                    cursor: 'pointer',
                    gap: '4px',
                  }}
                >
                  <BillIcon width={18} height={18} />
                  <Link underline="always" role="button">
                    {t('REGISTRATION_SAMPLE_BILL')}
                  </Link>
                </Box>
              </SampleBill>
            </Box>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AccountSection;
